import { FunctionComponent, ReactElement, ReactNode } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import Breadcrumbs from '@/components/ui/breadcrumbs';
import { BreadcrumbItem } from '@/components/ui/breadcrumbs/types';
import { classNames } from '@/shared/utils/componentHelpers';

export interface AdminPanelPageProps {
	title: ReactNode | string;
	children: ReactNode;
	breadcrumbs?: BreadcrumbItem[];
	headerControls?: ReactNode;
	hideHeaderOnPrint?: boolean;
	className?: string;
}

const AdminPanelPage: FunctionComponent<AdminPanelPageProps> = ({
	title,
	children,
	breadcrumbs,
	headerControls,
	hideHeaderOnPrint = false,
	className,
}): ReactElement => (
	<Box component="main" role="main" className={classNames('admin-panel-page', className)}>
		{breadcrumbs && (
			<Box sx={{ marginBottom: 2, displayPrint: hideHeaderOnPrint ? 'none' : undefined }}>
				<Breadcrumbs items={breadcrumbs} />
			</Box>
		)}
		<Box
			sx={{
				position: 'sticky',
				top: 0,
				backgroundColor: 'background.paper',
				borderRadius: 2,
				boxShadow: 1,
				marginBottom: 2,
				displayPrint: hideHeaderOnPrint ? 'none' : undefined,
				zIndex: (theme) => theme.zIndex.appBar,
			}}
			component={Paper}
			className="dashboard-item"
			padding={2}
		>
			<Stack direction="row" alignItems="center">
				<Typography component="h1" variant="h4" sx={{ fontWeight: 'bold', mr: 2 }}>
					{title}
				</Typography>
				<Box flexGrow={1} />
				{headerControls}
			</Stack>
		</Box>
		{children}
	</Box>
);

export default AdminPanelPage;
